import type React from 'react'
import { useState } from 'react'

import { Alert, Button, Icon, Input, Typography } from 'components'
import { ROUTES, URL_CONST } from 'constants/urls'
import { AuthLayout } from 'layouts/AuthLayout'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { sendCodeRequest } from 'services/forgetPassword'
import { theme } from 'styles/theme/hav-theme'

import type { CodeResponseStorage } from './components/types/responses'
import * as S from './styles'

const { forgetPassword } = ROUTES

const SendEmailForm: React.FC = () => {
  const [email, setEmail] = useState<string>('')
  const [showEmailError, setShowEmailError] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowEmailError(false)
    const { value } = e.target
    setEmail(value)
  }

  // TODO: Remove comment when email domain validation is enabled
  // const isInvalidDomainEmail =
  //   !isDevelopment && !isValidDomainEmail(email) && email !== ''

  const hasFormError = () => {
    return email === '' // || isInvalidDomainEmail // TODO: Remove comment when email domain validation is enabled
  }

  const handleSendCodeValidation = async (event: React.FormEvent) => {
    event.preventDefault()
    setLoading(true)
    try {
      // envio de e-mail de validação
      const response = await sendCodeRequest({
        ds_emai: email,
      })

      const { return_code } = response

      // NOTE: Email tied to another profile
      if (return_code === 6012) {
        setShowEmailError(true)
        return
      }
      // NOTE: Email not found in database
      if (return_code === 11) {
        toast.error('Email não registrado. Contate o backoffice para mais informações.')
        return
      }

      const composeStorage: CodeResponseStorage = {
        email: email,
        id_usua: response.id_usua,
        nm_usua: response?.nm_usua || '',
        return_chav: response.return_chav,
        return_code: response.return_code,
      }
      localStorage.setItem('resetPassword', JSON.stringify(composeStorage))
      setLoading(false)
      setShowEmailError(false)
      navigate(forgetPassword.getLink('validateCode'))
    } catch (error) {
      toast.error('Erro ao enviar código de validação')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <form autoComplete="true" onSubmit={handleSendCodeValidation}>
        <S.FieldsWrapper>
          <Typography className="forgetTitle" design="hav-h5-text">
            Esqueceu sua senha?
          </Typography>

          <Typography className="forgetDescriptionWithoutPad">
            Preencha o campo abaixo e enviaremos um código de verificação de cadastro.
          </Typography>
          {showEmailError && (
            <S.ErrorWrapper>
              <Alert
                fullWidth
                kind="error"
                message={
                  <>
                    Para resetar a sua senha ligue para <strong>(11) 3847-7477</strong>.
                  </>
                }
                title="E-mail atrelado à outros perfis."
              />
            </S.ErrorWrapper>
          )}
          <Input
            height={40}
            InputProps={{
              autoFocus: true,
              inputProps: { maxLength: 100 },
              placeholder: 'Insira seu email',
            }}
            label="Email"
            name="cd_usua"
            onChange={handleInputChange}
            type="email"
            value={email}
            // error={isInvalidDomainEmail ? invalidEmailDomainError.description : null} // TODO: Uncomment when email domain validation is enabled
          />
        </S.FieldsWrapper>
        <S.ButtonWrapper>
          <Button
            content="Enviar código"
            disabled={hasFormError()}
            fullWidth
            loading={loading}
            type="submit"
          />
        </S.ButtonWrapper>
        <S.LinkGoBackContainer>
          <S.LinkGoBack href={URL_CONST.LOGIN}>
            <Icon color={theme.colors.primary.main} icon="chevron-left" size="15" />
            Voltar
          </S.LinkGoBack>
        </S.LinkGoBackContainer>
      </form>
    </AuthLayout>
  )
}

export default SendEmailForm
